import { render } from "./InspecaoSecao3.vue?vue&type=template&id=d1965d98&scoped=true&ts=true"
import script from "./InspecaoSecao3.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao3.vue?vue&type=script&lang=ts"

import "./InspecaoSecao3.vue?vue&type=style&index=0&id=d1965d98&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1965d98"]])

export default __exports__